import { HeadlessFormProvider } from '@delmonicos/shared-design-system-react/src/contexts/headless-form.provider';
import { SubmitHandlerWithDirtyFields } from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { GetTariffsPaginatedModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/tariffs/models/inputs/get-tariffs-paginated.model';
import { SubmitErrorHandler } from 'react-hook-form';

import { useFilterSearchTariffListContext } from '../../tariff.context';
import { TariffListFilterSearchFormStep1Controller } from '../tariff-list-filter-search-form-step-1/tariff-list-filter-search-form-step-1.controller';

export interface TariffListFilterSearchFormControllerProps {
  onError: SubmitErrorHandler<GetTariffsPaginatedModel>;
  onSubmit: SubmitHandlerWithDirtyFields<GetTariffsPaginatedModel>;
  onCancel: () => void;
}

export const TariffListFilterSearchFormController = (
  props: TariffListFilterSearchFormControllerProps,
): React.JSX.Element => {
  const { onError, onSubmit, onCancel } = props;
  const data = useFilterSearchTariffListContext();

  return (
    <HeadlessFormProvider<GetTariffsPaginatedModel>
      useFormProps={{
        mode: 'all',
        defaultValues: data,
      }}
      submitErrorHandler={onError}
      submitHandler={onSubmit}
      onCancel={onCancel}
      item={{
        fields: ['textToSearch'],
        component: <TariffListFilterSearchFormStep1Controller />,
      }}
    />
  );
};
